import React from 'react';
import { Shield } from 'lucide-react';
import { FadeInImage } from './FadeInImage';

interface PairAvatarProps {
  p1Id?: string | null;
  p2Id?: string | null;
  p1Image?: string | null;
  p2Image?: string | null;
  className?: string; // Ej: "w-12 h-12"
  onPlayerClick?: (id: string) => void;
  onHoverChange?: (id: string | null) => void;
}

export function PairAvatar({ 
  p1Id, p2Id, p1Image, p2Image, className = "w-12 h-12",
  onPlayerClick, onHoverChange 
}: PairAvatarProps) {
  
  return (
    <div className={`${className} relative shrink-0`}>
      {/* Jugador 1: Abajo/izquierda */}
      <div 
        onClick={(e) => { e.stopPropagation(); p1Id && onPlayerClick?.(p1Id); }}
        onMouseEnter={() => p1Id && onHoverChange?.(p1Id)}
        onMouseLeave={() => onHoverChange?.(null)}
        className="absolute bottom-0 left-0 w-[65%] h-[65%] rounded-full overflow-hidden z-10 transition-all duration-300 hover:scale-125 hover:z-[50] hover:ring-2 hover:ring-theme-primary cursor-pointer"
      >
        {p1Image ? (
          <FadeInImage src={p1Image} alt="P1" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-white/5">
            <Shield className="opacity-20 w-1/2 h-1/2" />
          </div>
        )}
      </div>

      {/* Jugador 2: Arriba/derecha */}
      <div 
        onClick={(e) => { e.stopPropagation(); p2Id && onPlayerClick?.(p2Id); }}
        onMouseEnter={() => p2Id && onHoverChange?.(p2Id)}
        onMouseLeave={() => onHoverChange?.(null)}
        className="absolute top-0 right-0 w-[65%] h-[65%] rounded-full overflow-hidden z-20 transition-all duration-300 hover:scale-125 hover:z-[50] hover:ring-2 hover:ring-theme-primary cursor-pointer"
      >
        {p2Image ? (
          <FadeInImage src={p2Image} alt="P2" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-white/5">
            <Shield className="opacity-20 w-1/2 h-1/2" />
          </div>
        )}
      </div>
    </div>
  );
}
